import React from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import { history } from '../routes';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { ToastContainer, notify } from '../libraries/notifications';
import { getOwner, formatFullname } from '../libraries/utils';

import { Form, Field } from 'react-final-form'
import PushNotifications from '../components/PushNotifications';

import prescriptionActions from '../context/prescriptions/actions';
import purchasesActions from "../context/purchases/actions";
import appointmentsActions from "../context/appointments/actions";
import usersActions from "../context/users/actions";
import businessesActions from "../context/businesses/actions";

import NavButtonBar from '../components/commons/NavButtonBar';
import Loader from '../components/commons/Loader';
import Sidebar from '../components/layout/Sidebar';
import SearchInput from '../components/forms/SearchInput';
import AppointmentCard from "../components/customs/AppointmentCard";
import PurchaseCard from '../components/customs/PurchaseCard';
import PrescriptionElement from '../components/customs/PrescriptionElement';
import Button from '../components/commons/Button';


class Home extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      prescriptions: [],
      appointments: [],
      purchases: [],
      search: "",
    }
  }

  componentDidMount() {
    this.checkPurchaseParams();
    
    this.getPrescriptions();
    this.getAppointments();
    this.getPurchases();
    this.getUsersNumbers();
    this.getPharmaciesNumbers();
  }

  checkPurchaseParams = async () => {
    try {
      let url_str = window.location.href
      let url = new URL(url_str)
      if(url){
        let params = new URLSearchParams(url.search);

        let payment_id = params.get("payment_id")
        let status = params.get("status")
        let external_reference = params.get("external_reference")
        
        if(payment_id && status && external_reference){
          let trx_id = external_reference.replace('TRXID_', '')
          await this.props.onConfirmPayment({
            payment_id,
            status,
            external_reference,
          })
          
          history.push(config.ROUTES.MESSAGES)
          return true
        }
      }
    } catch (error) {
      return false
    }
  }

  getUsersNumbers = async () => {
    await this.props.onGetAllProfessionals({ user_type: config.USER_TYPE.PROFESSIONAL, enabled: 1, status: config.USER_ACCOUNTS.STATUS.ACTIVE });
    const { professionals } = this.props;
    if (professionals.error) {
      notify(this.t(professionals.error.message));
    } else {
      this.setState({ professionals: professionals.query ? professionals.query.records : 0 });

    }
  }

  getPharmaciesNumbers = async () => {
    const params = { type: config.USER_TYPE.PHARMACY, enabled: 1 }
    await this.props.onGetAllPharmacies(params);
    const { pharmacies } = this.props;
    if (pharmacies.error) {
      notify(this.t(pharmacies.error.message));
    } else {
      this.setState({ pharmacies: pharmacies.query ? pharmacies.query.records : 0 });
    }
  }

  getPrescriptions = async () => {
    await this.props.onGetAllPrescriptions({ target: getOwner(this.props.auth.user) });
    const { prescriptions } = this.props;
    if (prescriptions.error) {
      notify(this.t(prescriptions.error.message));
    } else {
      this.setState({ prescriptions: prescriptions.items.slice(0, 4) });
    }
  }

  getAppointments = async () => {
    await this.props.onGetAllAppointments({ target: getOwner(this.props.auth.user), });
    const { appointments } = this.props;
    appointments.items = appointments.items.filter(appointment =>
      [config.TRANSACTIONS.BOOK.STATUS.BOOKED, config.TRANSACTIONS.BOOK.STATUS.IN_PROGRESS].includes(appointment.status)
    )
    if (appointments.error) {
      notify(this.t(appointments.error.message));
    } else {
      this.setState({
        appointments: appointments.items
          .filter((a) => new Date() <= new Date(a.date))
          .slice(0, 4)
      });
    }
  };

  getPurchases = async () => {
    await this.props.onGetAllPurchases({ target: getOwner(this.props.auth.user), status: config.TRANSACTIONS.PURCHASE.STATUS.OPEN });
    const { purchases } = this.props;
    if (purchases.error) {
      notify(this.t(purchases.error.message));
    } else {
      this.setState({ purchases: purchases.items.slice(0, 4) });
    }
  };

  onSearch = values => {
    if (this.state.search !== values.search){
      this.setState({ search: values.search || '' });
    }
  }

  searchClear = (form) => {
    form.change('search', undefined);
    this.setState({ search: '' });
  }

  render() {
    // Notification.requestPermission( 
    //   function(status) { 
    //     if (status !== 'granted') {
    //       Notification.requestPermission();
    //     } else {
    //       console.log('Permission granted');
    //     }
    //  })
    const { professionals, pharmacies } = this.state;

    const options = [
      {
        onClick: () => history.push(config.ROUTES.PROFESSIONALS),
        icon: "stethoscope", iconClassName: "h-8 w-8 mr-2 text-success mb-3",
        content: [
          <h4 key={1} className="mb-5">{this.t("Profesionales")}</h4>,
          <small key={2}>+{professionals} especialistas</small>
        ]
      },
      {
        onClick: () => history.push(config.ROUTES.PHARMACIES),
        icon: "pharmacy", iconClassName: "h-8 w-8 mr-2 text-success mb-3",
        content: [
          <h4 key={1} className="mb-5">{this.t("Farmacias")}</h4>,
          <small key={2}>+{pharmacies} disponibles</small>
        ]
      },
      //{ 
      //  icon: "home", iconClassName: "h-8 w-8 mr-2 text-success mb-3",
      //  content: [
      //    <h4 key={1} className="mb-5">{this.t("Instituciones")}</h4>,
      //    <small key={2}>+50 disponibles</small>
      //  ]
      //},
    ]

    const { appointments, prescriptions, purchases, } = this.state;
    const user = this.props.auth.user;
    return (
      <main className="w-full h-full bg-base-200 text-base-content">
        <PushNotifications user={this.props.auth.user} />
        <Sidebar
          header={{
            logo: false,
          }}
        />
        <ToastContainer />
        <section className="bg-primary text-primary-content p-1 pb-6">
          <div className="px-4 max-w-lg mx-auto">
            <h1 className="mb-4">
              <span className="font-light	block">{this.t("Bienvenido")}</span>
              {formatFullname(user)}
            </h1>
            <NavButtonBar
              buttonClassName="p-4 mr-3 w-40 shadow-2xl text-base-content items-start"
              options={options} />
          </div>
        </section>
        <div className="section-card">
          <section className="mb-6">
            <Form initialValues={{}} onSubmit={this.onSearch}>
              {({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                  <Field name="search" component={SearchInput} placeholder={this.t("Buscar...")} onClick={this.onSearch} inputClassName="rounded-full mb-5" onClearClick={() => this.searchClear(form)}/>
                </form>
              )}
            </Form>
          </section>
          <section className="mb-10">
            <div className="flex items-end justify-between mb-2 px-2">
              <h2>{this.t("Próximas consultas")}</h2>
              {appointments.length != 0 && (
                <Button className="btn btn-xs btn-ghost text-gray-500" title={this.t("Ver todas")}
                  onClick={() => history.push(config.ROUTES.APPOINTMENTS.LIST)}
                />
              )}
            </div>
            {this.props.appointments.loading && (<Loader />)}
            {!this.props.appointments.loading && appointments.length === 0 && (
              <small className="mb-1 text-gray-500 px-2">{this.t("No tenes turnos de consultas")}</small>
            )}
            {appointments && appointments.map((appointment, index) => (
              <AppointmentCard
                key={index}
                route={{ pathname: config.ROUTES.APPOINTMENTS.DETAIL.replace(':id', appointment.id), state: { from: config.ROUTES.HOME } }}
                appointment={appointment}
              />
            ))}
          </section>
          <section className="mb-10">
            <div className="flex items-end justify-between mb-2 px-2">
              <h2>{this.t("Últimas recetas")}</h2>
              {prescriptions.length != 0 && (
                <Button className="btn btn-xs btn-ghost text-gray-500" title={this.t("Ver todas")}
                  onClick={() => history.push(config.ROUTES.PRESCRIPTIONS)}
                />
              )}
            </div>
            {this.props.prescriptions.loading && (<Loader />)}
            {!this.props.prescriptions.loading && prescriptions.length === 0 && (
              <small className="mb-1 text-gray-500 px-3">{this.t("No tienes prescripciones")}</small>
            )}
            <div className="card white">
              {prescriptions && prescriptions.map((prescription, index) => {
                return (
                  <Link
                    key={index}
                    to={config.ROUTES.PRESCRIPTION.replace(':id', prescription.id)}
                  >
                    <PrescriptionElement
                      key={index}
                      prescription={prescription}
                      className="border-b p-4"
                    />
                  </Link>
                )
              }
              )}
            </div>
          </section>
          <section className="">
            <div className="flex items-end justify-between mb-2 px-2">
              <h2>{this.t("Compras en farmacias")}</h2>
              {purchases.length != 0 && (
                <Button className="btn btn-xs btn-ghost text-gray-500" title={this.t("Ver todas")}
                  onClick={() => history.push(config.ROUTES.PURCHASES.LIST)}
                />
              )}
            </div>

            {this.props.purchases.loading && (<Loader />)}
            {!this.props.purchases.loading && purchases.length === 0 && (
              <small className="mb-1 text-gray-500 px-3">{this.t("No tienes compras realizadas")}</small>
            )}

            {purchases && purchases.map((purchase, index) => (
              <PurchaseCard
                key={index}
                route={config.ROUTES.PURCHASES.DETAIL.replace(':id', purchase.id)}
                purchase={purchase}
              />
            ))}

          </section>
        </div>
      </main>

    )
  }
}


const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    prescriptions: state.prescriptions.list,
    purchases: state.purchases.list,
    appointments: state.appointments.list,
    professionals: state.users.list,
    pharmacies: state.businesses.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllPurchases: (params) => dispatch(purchasesActions.getAll(params)),
    onGetAllAppointments: (params) => dispatch(appointmentsActions.getAll(params)),
    onGetAllPrescriptions: (params) => dispatch(prescriptionActions.getAll(params)),
    onGetAllProfessionals: (params) => dispatch(usersActions.getAll(params)),
    onGetAllPharmacies: (params) => dispatch(businessesActions.getAll(params)),
    onConfirmPayment: (params) => dispatch(purchasesActions.confirmPayment(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Home));
